import React from "react";
import { useLocation } from "react-router-dom";
import CloudSecurityCenter from "./cloud/CloudSecurityCenter.jsx";
import AwsDashboardLegacy from "./s-item-3-1-aws-Legacy.jsx";

const AwsDashboard = () => {
  const { search } = useLocation();
  const requestedView = new URLSearchParams(search).get("cloudDashboard");
  const v3Enabled =
    String(process.env.REACT_APP_CLOUD_DASHBOARD_V3).toLowerCase() === "true";
  const showV3 =
    requestedView === "v3" || (requestedView !== "legacy" && v3Enabled);

  return showV3 ? (
    <CloudSecurityCenter initialProviderScope="aws" />
  ) : (
    <AwsDashboardLegacy />
  );
};

export default AwsDashboard;
